import styles from "./index.module.css";

export const UploadLoading = () => {
  return (
    <>
      <div className={styles.loading}></div>
    </>
  );
};
